/**
 * Loads CustomerEditModule to allow Customer Edit functionality on the fly
 * Uses media query to determine viewport mode
 */

import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import { useOktaAuth } from '@okta/okta-react';
import type { FC } from 'react';
import { Suspense } from 'react';
import { CustomerEditModule } from './CustomerEditModule';
import { RemoteModuleErrorBoundary } from './RemoteModuleErrorBoundary';
import SalesCheckInSpinner from '../SalesCheckInSpinner/SalesCheckInSpinner';
import { useMediaQuery } from 'react-responsive';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import type { CustomerEditProps } from '@makemydeal/dr-sales-checkin-types';
import { CUSTOMER_REQUIRED_FIELDS_FOR_PBC } from '@makemydeal/dr-sales-checkin-types';

export const EditCustomer: FC<CustomerEditProps> = ({ commonConsumer, onCustomerSave }) => {
    const environment = offerSessionUtils.getEnvironmentType();
    const oktaContext = useOktaAuth();
    const getJwtToken = () => oktaContext?.oktaAuth.getAccessToken() || '';
    const isLargerThanSmall = useMediaQuery({ query: `(min-width: ${BreakPoint.SMALL})` });
    const viewportMode = isLargerThanSmall ? 'desktop' : 'mobile';

    return (
        <RemoteModuleErrorBoundary moduleName="CustomerEditModule" commonConsumerId={commonConsumer.consumerId}>
            <Suspense fallback={<SalesCheckInSpinner />}>
                <CustomerEditModule
                    didSaveOrDiscard={onCustomerSave}
                    environment={environment}
                    viewportMode={viewportMode}
                    commonConsumer={commonConsumer}
                    getAuthOverride={getJwtToken}
                    enableReadOnlyFields={true}
                    requiredFields={CUSTOMER_REQUIRED_FIELDS_FOR_PBC}
                />
            </Suspense>
        </RemoteModuleErrorBoundary>
    );
};
